import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import SSOConfirmationPopup from '@/components/cards/sso-confirmation-popup/sso-confirmation-popup';
import SSOSaml from '@/components/cards/sso-providers/sso-saml/sso-saml';
import SSOLTI from '@/components/cards/sso-providers/sso-lti/sso-lti';
import SSOApple from '@/components/cards/sso-providers/sso-apple/sso-apple';
import { ssoSetupApi } from '@/providers/apis/sso-setup/sso-setup';

@Component({
    name: 'sso-config',
    components: {
        'material-icons': GoogleMaterialIcon,
        'provider': () => import('@/components/cards/providers/providers.vue'),
        'organization': () => import('@/components/cards/setup-organization/setup-organization.vue'),
        // 'activated-service': () => import('@/components/cards/sso-final-setup/sso-final-setup.vue'),
        'sso-google': () => import('@/components/cards/sso-providers/sso-google/sso-google'),
        'sso-wsfed': () => import('@/components/cards/sso-providers/sso-wsfed/sso-wsfed'),
        'sso-oauth2': () => import('@/components/cards/sso-providers/sso-oauth2/sso-oauth2'),
        'sso-confirmation-popup': SSOConfirmationPopup,
        'sso-saml': SSOSaml,
        'sso-lti': SSOLTI,
        'sso-apple': SSOApple,
    },
})

export default class SSOSetup extends Vue {

    public configList: any = [];

    public ssoFields: any = [];

    public isLoading: boolean = false;

    private isEditAllow: boolean = false;

    private lusdId: string = '';

    private isShowConfirmationPullup: boolean = false;
    // -------------------------------------------------------------------
    // Properties
    private ssoSteps: any = [
        {
            name: 'Step 1',
            key: 'provider',
        },
        {
            name: 'Step 2',
            key: 'organization',
        },
        {
            name: 'Step 3',
            key: 'activated-service',
        },
    ];

    private providerList: any = [
        {
            text: 'Google',
            value: 'google',
        },
        {
            text: 'WSFED',
            value: 'WSFED',
        },
        {
            text: 'OAUTH2',
            value: 'OAUTH2',
        },
        {
            text: 'SAML',
            value: 'saml',
        },
        {
            text: 'LTI',
            value: 'ltisso',
        },
        {
            text: 'Apple',
            value: 'apple',
        },
    ];

    private ssoComponents: any = {
        google: 'sso-google',
        WSFED: 'sso-wsfed',
        OAUTH2: 'sso-oauth2',
        saml: 'sso-saml',
        ltisso: 'sso-lti',
        apple: 'sso-apple',
        none: 'organization',
    };

    private activeStep: any = 'provider';

    // ----------------------------------------------------------------------------------
    // Actions

    private onGoNext(selectedKey: any) {
        if (selectedKey) {
            this.fetchConfigList(selectedKey);
            this.isEditAllow = false;
            this.activeStep = this.ssoComponents[selectedKey];
        }
    }

    private onBack() {
        this.ssoFields = [];
        this.isEditAllow = false;
        this.activeStep = 'provider';
    }

    // ------------------------------------------------------------------------------
    // Methods
    private parseBindContent() {
        const cardName = 'SSO Setup';
        const providerList = this.providerList;
        return {
            providerList,
            cardName,
        };
    }

    private onEdit() {
        this.isEditAllow = true;
    }

    private onSubmit(data: any) {
        this.isShowConfirmationPullup = true;
    }

    private onConfirmOk() {
        this.isShowConfirmationPullup = false;
    }

    private fetchConfigList(selectedKey: string) {
        this.isLoading = true;
        ssoSetupApi.getConfigBasedOnSso(selectedKey).then((ssoConfigList: any) => {
            const configDetails = ssoConfigList.sso_config;
            const tenantId = this.$access.getTenantId();
            configDetails.forEach((configList: any) => {
                this.lusdId = configList.id;
                if (tenantId === this.lusdId) {
                    this.ssoFields = configList.config;
                }
            });
            this.isLoading = false;
        });

    }
}
